<template>
  <router-view></router-view>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "App",
  data: () => ({}),
  computed: {
    ...mapGetters({
      isAuthenticated: "auth/isAuthenticated",
    }),
  },
  mounted() {
    // Start the idle timer when the component is mounted
    this.startIdleTimer();
  },
  beforeDestroy() {
    // Clear the idle timer when the component is destroyed
    this.clearIdleTimer();
    // Remove the event listeners for user activity
    ["mousemove", "keydown", "mousedown", "touchstart"].forEach((event) => {
      window.removeEventListener(event, this.resetIdleTimer);
    });

    // Remove the beforeunload event listener when the component is destroyed
  },
  methods: {
    ...mapActions({
      logOut: "auth/logOut",
    }),
    startIdleTimer() {
      this.clearIdleTimer();

      if (!this.isAuthenticated) return;

      this.idleTimeout = setTimeout(
        () => {
          this.logOut(); // 30 dakika sonra logout
        },
        120 * 60 * 1000,
      ); // 30 dakika = 1800000 ms

      ["mousemove", "keydown", "mousedown", "touchstart"].forEach((event) => {
        window.addEventListener(event, this.resetIdleTimer);
      });
    },
    resetIdleTimer() {
      this.clearIdleTimer();
      this.startIdleTimer();
    },
    clearIdleTimer() {
      clearTimeout(this.idleTimeout);
    },
  },
  watch: {
    isAuthenticated(newValue) {
      if (newValue) {
        this.startIdleTimer();
      }
    },
  },
};
</script>
<style lang="scss"></style>
